<template>
  <div class='emails-viewer'>
    <v-switch v-model='showNames' label='Show Names'></v-switch>
    <v-list expand>
      <v-list-group v-for='(emails, type) in emailResults' :key='type' :value='false'>
        <template v-slot:activator><v-list-item-content><v-list-item-title> {{ type }} </v-list-item-title> <v-chip style='float: right; font-weight: 600;'>{{ emails.length }}</v-chip></v-list-item-content></template>
        <v-data-table
          :headers='tableHeaders'
          :items='emails'
          :items-per-page='Infinity'
          hide-default-footer
        />
      </v-list-group>
    </v-list>
  </div>
</template>

<script>
import AdminService from '@/services/TPC/AdminService'

export default {
  name: 'emails-viewer',
  data () {
    return {
      showNames: true,
      emailResults: {},
    }
  },
  props: {
    roundID: String,
  },
  async created () {
    let {data: rdata} = await AdminService.getEmails('round_registered', {roundID: this.roundID})
    if (rdata.error) {
      alert(`Error: ${rdata.error} - ${rdata.message}`)
    } else {
      this.$set(this.emailResults, 'ROUND REGISTERED', rdata.result)
    }

    let {data: vdata} = await AdminService.getEmails('no_video', {roundID: this.roundID})
    if (vdata.error) {
      alert(`Error: ${vdata.error} - ${vdata.message}`)
    } else {
      this.$set(this.emailResults, 'NO VIDEO', vdata.result)
    }

    let {data: sdata} = await AdminService.getEmails('no_submission', {roundID: this.roundID})
    if (sdata.error) {
      alert(`Error: ${sdata.error} - ${sdata.message}`)
    } else {
      this.$set(this.emailResults, 'NO SUBMISSION', sdata.result)
    }
    console.log(this.tableHeaders)
  },
  computed: {
    tableHeaders () {
      let headers = [{text: 'Email', value: 'email'}]
      if (this.showNames) headers = headers.concat([{text: 'Name', value: 'name'}])
      return headers
    }
  },
}
</script>

<style scoped>
.v-list-item__content {
  text-align: left;
}
</style>
